import { HaveNotRedirectParamError } from './HaveNotRedirectParamError';
import { NotTheSameOriginError } from './NotTheSameOriginError';
import { NotValidURLError } from './NotValidURLError';
import { REDIRECT_PARAM_NAME } from './REDIRECT_PARAM_NAME';

export const getSafeRedirectParam = (): Promise<URL> => {
  return new Promise((resolve, reject) => {
    const urlParams = new URLSearchParams(window.location.search);
    const param = urlParams.get(REDIRECT_PARAM_NAME);

    if (!param) {
      reject(new HaveNotRedirectParamError());
      return;
    }

    try {
      const urlFromParam = new URL(param, window.location.origin);

      if (urlFromParam.origin !== window.location.origin) {
        reject(new NotTheSameOriginError());
        return;
      }

      resolve(urlFromParam);
    } catch (e) {
      console.error(e);
      reject(new NotValidURLError());
    }
  });
};